import * as React from 'react'

import {Box} from "@mui/material";


export default function keywordColumn() {
    return {
		name: 'keyword', label: 'Keyword',
		options: {
			filter: false,
			customBodyRowRenderLite: value => <Box sx={{textAlign: 'center'}}>
				{value}
			</Box>
		}
	}
}